import { useRef, useState, useEffect, useMemo, forwardRef } from 'react';
import ReactDOM from 'react-dom';
import { getSecureMathRandom } from '@financial/common-utils';

function usePortal() {
  const portal = useRef();
  const [portalCreated, setPortalCreated] = useState(false);
  useEffect(() => {
    if (!portal.current) {
      // Math.random()을 이용하여 id를 생성한 이유는, 한 페이지에서 충돌이 있을만큼 호출하지 않는다고 판단함.
      const portalId = getSecureMathRandom().toString(36).substring(2);
      portal.current = document.createElement('div');
      portal.current.id = `portal__${portalId}`;
      document.body.appendChild(portal.current);
      setPortalCreated(true);
    }
    return () => {
      if (portal.current?.parentNode) {
        const {
          parentNode
        } = portal.current;
        parentNode.removeChild(portal.current);
        portal.current = null;
        setPortalCreated(false);
      }
    };
  }, []);
  const Portal = useMemo(() => /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      children
    } = _ref;
    if (!portal.current || !portalCreated) {
      return null;
    }
    if (ref) {
      ref.current = portal.current;
    }
    return /*#__PURE__*/ReactDOM.createPortal(children, portal.current);
  }), [portalCreated]);
  return Portal;
}

export { usePortal as default };
